// extracted by mini-css-extract-plugin
export var lbContainerOuter = "x_tY";
export var lbContainerInner = "x_tZ";
export var movingForwards = "x_t0";
export var movingForwardsOther = "x_t1";
export var movingBackwards = "x_t2";
export var movingBackwardsOther = "x_t3";
export var lbImage = "x_t4";
export var lbOtherImage = "x_t5";
export var prevButton = "x_t6";
export var nextButton = "x_t7";
export var closing = "x_t8";
export var appear = "x_t9";